const { types, referenceTypes, uiTypes } = require("../utils/types");
const { validatorTypes } = require("../utils/validatorTypes");

const textValuesUI = {
  // added for ui
  type: uiTypes.TEXT, //UI Types
  validation: [], //UI Validation
  list: false,
  read: true,
  create: true,
  edit: true,
};
const obj = {
  tableName: "homes",
  read: true,
  create: true,
  edit: true,
  delete: true,
  comments: false, //for enabiling comments on view and edit
  references: [],
  columns: [
    {
      name: "id",
      type: types.UUID,
      allowNull: false,
      defaultValue: types.UUIDV4,
      primaryKey: true,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "header_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        validation: [validatorTypes.string, validatorTypes.required],
        list: true,
      },
    },
    {
      name: "header_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        validation: [validatorTypes.string, validatorTypes.required],
        list: true,
      },
    },
    {
      name: "video",
      type: types.JSON,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.json, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.VIDEO, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "tags",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "name",
            type: "text", //image , text, textarea
          },
          {
            name: "priority",
            type: "text", //image , text, textarea
          },
          {
            name: "vector_art",
            type: "image", //image , text, textarea
          },
        ], // incas
      },
    },
    {
      name: "property_type_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        validation: [validatorTypes.string, validatorTypes.required],
      },
    },
    {
      name: "property_type_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "summary_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "summary_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "summary",
      type: types.TEXT,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        type: uiTypes.TEXT_AREA,
        ...textValuesUI,
      },
    },
    {
      name: "summary_items",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "title",
            type: "text", //image , text, textarea
          },
          {
            name: "priority",
            type: "text", //image , text, textarea
          },
          {
            name: "subtitle",
            type: "text", //image , text, textarea
          },
          {
            name: "vector_art",
            type: "image", //image , text, textarea
          },
        ], // incas
      },
    },

    {
      name: "homeBoxImage",
      type: types.JSON,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.json, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DOCUMENT_ALT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "counters",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "title",
            type: "text", //image , text, textarea
          },
          {
            name: "priority",
            type: "text", //image , text, textarea
          },
          {
            name: "subtitle",
            type: "text", //image , text, textarea
          },
          {
            name: "count",
            type: "text", //image , text, textarea
          },
        ], // incas
      },
    },
    {
      name: "country_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "country_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "transaction_type_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "transaction_type_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "marquee_bar",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "testimonials_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        type: uiTypes.TEXT_AREA,
      },
    },

    {
      name: "testimonials_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "testimonials",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "name",
            type: "text", //image , text, textarea
          },
          {
            name: "priority",
            type: "text", //image , text, textarea
          },
          {
            name: "designation",
            type: "text", //image , text, textarea
          },
          {
            name: "color_code",
            type: "text", //image , text, textarea
          },
          {
            name: "description",
            type: "textarea", //image , text, textarea
          },
          {
            name: "photo",
            type: "image", //image , text, textarea
          },
          {
            name: "banner",
            type: "image", //image , text, textarea
          },
        ], // incas
      },
    },

    {
      name: "blogs_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "blogs_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        type: uiTypes.TEXT_AREA,
      },
    },

    {
      name: "our_partners_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        type: uiTypes.TEXT_AREA,
      },
    },

    {
      name: "our_partners_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        type: uiTypes.TEXT_AREA,
      },
    },

    {
      name: "our_partners",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "link",
            type: "text", //image , text, textarea
          },
          {
            name: "priority",
            type: "text", //image , text, textarea
          },
          {
            name: "image",
            type: "image", //image , text, textarea
          },
          {
            name: "name",
            type: "text", //image , text, textarea
          },
          {
            name: "description",
            type: "textarea", //image , text, textarea
          },
        ], // incas
      },
    },

    {
      name: "enabled",
      type: types.BOOLEAN,
      isArray: false,
      defaultValue: true,
      validation: [validatorTypes.bool, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.SWITCH, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "createdAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        // added for ui
        type: uiTypes.DATE, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "updatedAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        // added for ui
        type: uiTypes.DATE, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "deletedAt",
      type: types.DATE,
      allowNull: true,
      defaultValue: null,
      read: false,
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: false,
        create: false,
        edit: false,
      },
    },
  ],
};
module.exports = obj;
